// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2b-2";
export var placeholderIcon = "_2b-3";
export var thumbnailCanvas = "_2b-1";
export var thumbnailWrapper = "_2b-0";